import dateUtil from '@/tools/dateUtil'
import dayjs from 'dayjs'
const validateAnswer = function (errors, vm) {
  let { value, answerConfig: { requireInd, paramInt01, paramInt02, limitRangeInd, timeType } } = this
  if (requireInd === '1') {
    if (vm.$util.isNull(value)) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      return !errors.length
    }
  }
  if (!value) {
    return !errors.length
  }
  if (limitRangeInd === '1' && timeType === '04') {
    let compareValue = dayjs(value).unix() * 1000
    // 过滤配置端点此刻产生的s
    paramInt02 = paramInt02 ? dayjs(dateUtil.date2Str(new Date(paramInt02 * 1), 'yyyy-MM-dd hh:mm')).unix() * 1000 : 0
    paramInt01 = paramInt01 ? dayjs(dateUtil.date2Str(new Date(paramInt01 * 1), 'yyyy-MM-dd hh:mm')).unix() * 1000 : 0
    
    let errorMin = paramInt02 ? dateUtil.date2Str(new Date(paramInt02 * 1), 'yyyy-MM-dd hh:mm') : '-'
    let errorMax = paramInt01 ? dateUtil.date2Str(new Date(paramInt01 * 1), 'yyyy-MM-dd hh:mm') : '-'

    if (
      (paramInt02 && paramInt01 && !(compareValue >= paramInt02 && compareValue <= paramInt01)) ||
      (paramInt02 && !paramInt01 && !(compareValue >= paramInt02)) ||
      (!paramInt02 && paramInt01 && !(compareValue <= paramInt01))
    ) {
      errors.push(`${vm.cvtLang('datetimeRange', this.datetimeRange)}: ${errorMin || '-'} ~ ${errorMax || '-'}`)
    }
  }
  return !errors.length
}

const validate = function (vm) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm),
    errors
  }
}

const answerValidate = {
  validateAnswer,
  validate
}

export default answerValidate



// WEBPACK FOOTER //
// ./src/components/editor/TimeBox/answerValidate.js